import { jsx as a, jsxs as y, Fragment as R } from "react/jsx-runtime";
import { IconNames as U } from "@blueprintjs/icons";
import { formatDate as Y, DateFormats as G } from "@strata/helper-functions";
import { ActionButtonText as W } from "@strata/react-buttons";
import { CheckboxListFormik as q, Checkbox as z } from "@strata/react-checkbox-list";
import { DateInputFormik as J } from "@strata/react-date-time";
import { FileUploadFormik as N } from "@strata/react-file-upload";
import { FormFieldWrapper as X } from "@strata/react-form-field-wrapper";
import { formatMarkDownLinks as Q } from "@strata/react-hyperlink";
import { TextInputFormik as $, NumberInputFormik as Z, TextAreaFormik as tt } from "@strata/react-inputs";
import { RadioButtonGroupFormik as H } from "@strata/react-radio-button-group";
import { SuggestSingleSelectFormik as j } from "@strata/react-selects";
import { Icon as et } from "@strata/react-status-icons";
import { validationStrings as O } from "@strata/strata-ui-strings";
import { useFormikContext as it, getIn as m, FieldArray as rt } from "formik";
import { useMemo as ot, useEffect as at, createElement as st } from "react";
import * as h from "yup";
import "./main.scss";
const k = (e = {}) => {
  const s = Object.keys(e), d = new Set(s), u = Object.fromEntries(
    s.map((p) => {
      var T;
      return [p, (T = e[p]) == null ? void 0 : T.validationSchema];
    })
  );
  return { customComponentsList: s, customComponentsSet: d, customComponentsValidationSchemas: u };
}, M = {
  TEXT: "text",
  NUMBER: "number",
  TEXT_AREA: "text_area",
  SINGLE_SELECT: "single_select",
  CHECKBOX: "checkbox",
  DATE: "date",
  FILE_UPLOAD: "file_upload",
  RADIO_BUTTONS: "radio_buttons",
  CHECKBOX_LIST: "checkbox_list",
  FIELD_LIST: "field_list"
}, K = (e = {}) => ({
  ...M,
  ...e
}), _ = (e, s = !1, d = []) => {
  if (s) {
    let u = e;
    return d.forEach((p) => {
      u = u.concat(p);
    }), u.required(O.requiredField.errorMessage);
  }
  return e;
}, nt = ({
  fieldType: e,
  isRequired: s,
  customComponents: d,
  compProps: u
}) => {
  const { customComponentsList: p, customComponentsSet: T, customComponentsValidationSchemas: g } = k(d), n = K(p);
  switch (e) {
    case n.NUMBER:
      return _(h.number(), s);
    case n.CHECKBOX:
      return _(h.bool(), s);
    case n.DATE:
      return _(h.date(), s);
    case n.FILE_UPLOAD:
      return _(N.validator(), s, [
        N.validator().min(1, O.requiredField.errorMessage)
      ]);
    case n.RADIO_BUTTONS:
      return _(h.string(), s);
    case n.CHECKBOX_LIST:
      return _(h.array(h.string()), s);
    case n.TEXT:
      return _(
        h.string().max(100, O.maxCharacter[100]),
        s
      );
    case n.TEXT_AREA:
      return _(
        h.string().max(500, O.maxCharacter[500]),
        s
      );
    default: {
      if (!T.has(e))
        return _(h.string(), s);
      const o = g[e];
      return typeof o == "function" ? o(u) : o;
    }
  }
}, lt = ({
  props: e,
  type: s = "",
  customComponents: d,
  customComponentsSet: u
}) => u.has(s) ? st(d[s], e) : null, b = ({
  component: e,
  id: s,
  customComponents: d = void 0,
  fileUploadConfig: u = void 0,
  setOnSubmitCallbacks: p = void 0,
  setOnCancelCallbacks: T = void 0,
  onChange: g = void 0,
  onChangeCallback: n = void 0
}) => {
  const o = it(), { customComponentsList: P, customComponentsSet: B } = k(d), l = K(P), { uploadPathId: I, onAddFiles: x, onRemoveFile: v, onFileClick: L } = u ?? {}, i = {
    id: s,
    name: s,
    label: Q(e.label),
    required: e.required,
    placeholderText: e.placeholderText,
    helperText: e.helperText,
    verticalSpacingSmall: !0,
    disabled: e.disabled
  }, f = (t, r) => {
    g ? g(t) : r(t), n == null || n();
  }, A = (t) => f(t.target.value, (r) => {
    o.setFieldValue(i.id, r);
  }), C = (t) => f(t, (r) => {
    o.setFieldValue(i.id, r);
  }), E = `other.${i.id}`, F = "Other: ", S = ot(
    () => (t = m(o.values, i.id)) => t == null ? void 0 : t.startsWith(F),
    [o, i.id]
  );
  switch (at(() => {
    (async () => {
      var t;
      if (e.type === l.RADIO_BUTTONS && e.optionsDict && e.showOther && S() && m(o.values, E) === void 0) {
        const r = (t = m(o.values, i.id)) == null ? void 0 : t.slice(7);
        ((r == null ? void 0 : r.length) ?? 0) > 0 && await o.setFieldValue(E, r);
      }
    })();
  }, [o, i.id, E, e, l.RADIO_BUTTONS, S]), e.type) {
    case l.TEXT:
      return /* @__PURE__ */ a($, { ...i, onChange: A });
    case l.TEXT_AREA:
      return /* @__PURE__ */ a(tt, { ...i, onChange: A });
    case l.NUMBER:
      return /* @__PURE__ */ a(Z, { ...i, onChange: A });
    case l.DATE:
      return /* @__PURE__ */ a(
        J,
        {
          ...i,
          onChange: (t) => f(t, (r) => {
            o.setFieldValue(
              i.id,
              Y(r, G.HYPHEN_DATE)
            );
          }),
          value: m(o.values, i.id)
        }
      );
    case l.CHECKBOX:
      return /* @__PURE__ */ a(
        X,
        {
          label: "",
          required: i.required,
          inputContent: /* @__PURE__ */ a(
            z,
            {
              ...i,
              label: i.label,
              onChange: C,
              checked: m(o.values, i.id) ?? !1
            }
          )
        }
      );
    case l.SINGLE_SELECT:
      return e.optionsDict ? /* @__PURE__ */ a(
        j,
        {
          ...i,
          values: Object.entries(e.optionsDict).map(([t, r]) => ({
            name: r,
            value: t
          })),
          onChange: (t) => f(t == null ? void 0 : t.value, (r) => {
            o.setFieldValue(i.id, r);
          }),
          selectedItem: typeof m(o.values, i.id) == "string" ? {
            name: e.optionsDict[m(o.values, i.id)],
            value: m(o.values, i.id)
          } : void 0,
          itemsEqual: "value"
        }
      ) : /* @__PURE__ */ a(
        j,
        {
          ...i,
          values: [
            ...new Set(
              // TODO: Better typing based on component type should remove need for type assertion
              (e.options ?? []).filter((t) => t !== "")
            )
          ],
          onChange: C
        }
      );
    case l.FILE_UPLOAD:
      return /* @__PURE__ */ a(
        N,
        {
          ...i,
          onAddFiles: async (t) => {
            await (x == null ? void 0 : x(t, I)), T == null || T((r) => [
              ...r,
              ...t.map(({ name: c }) => async () => {
                await (v == null ? void 0 : v(c, I));
              })
            ]);
          },
          onRemoveFile: (t) => p == null ? void 0 : p((r) => [
            ...r,
            async () => {
              await (v == null ? void 0 : v(t, I));
            }
          ]),
          onFileClick: (t) => L == null ? void 0 : L(t, I)
        }
      );
    case l.RADIO_BUTTONS:
      if (e.optionsDict) {
        const t = Object.entries(e.optionsDict).map(([r, c]) => ({
          text: c,
          value: r
        }));
        return e.showOther && t.push({
          text: "Other",
          value: F,
          component: /* @__PURE__ */ y("div", { className: "sds_dynamic-input__other-text-input", children: [
            /* @__PURE__ */ a("div", { className: "padding__right--small", children: "Other:" }),
            /* @__PURE__ */ a(
              $,
              {
                id: E,
                disabled: !S(),
                onChange: (r) => f(`${F}${r.target.value}`, (c) => {
                  (async () => (await o.setFieldValue(i.id, c), await o.setFieldValue(E, r.target.value)))();
                }),
                verticalSpacingSmall: !0
              }
            )
          ] })
        }), /* @__PURE__ */ a(
          H,
          {
            ...i,
            options: t,
            onChange: (r) => {
              f(
                S(r) ? `${F}${m(o.values, E) ?? ""}` : r,
                (c) => {
                  o.setFieldValue(i.id, c);
                }
              );
            },
            selectedValue: S() ? F : m(o.values, i.id)
          }
        );
      }
      return /* @__PURE__ */ a(
        H,
        {
          ...i,
          options: [
            ...new Set(
              // TODO: Better typing based on component type should remove need for type assertion
              (e.options ?? []).filter((t) => t !== "")
            )
          ],
          onChange: C
        }
      );
    case l.CHECKBOX_LIST:
      return /* @__PURE__ */ a(
        q,
        {
          ...i,
          options: [
            ...new Set(
              // TODO: Better typing based on component type should remove need for type assertion
              (e.options ?? []).filter((t) => t !== "")
            )
          ],
          onChange: C
        }
      );
    case l.FIELD_LIST:
      return /* @__PURE__ */ a("div", { className: "sds_dynamic-input__options", children: /* @__PURE__ */ a(
        X,
        {
          label: i.label,
          helperText: i.helperText,
          verticalSpacingSmall: !0,
          inputContent: /* @__PURE__ */ a(rt, { name: i.id, children: (t) => {
            const r = m(o.values, i.id) ?? [], c = r.length, V = c > 1;
            return /* @__PURE__ */ y(R, { children: [
              r.map((dt, D) => {
                var w;
                return /* @__PURE__ */ y(
                  "div",
                  {
                    className: "sds_dynamic-input__option",
                    children: [
                      /* @__PURE__ */ a("div", { className: "sds_dynamic-input__option__text", children: /* @__PURE__ */ a(
                        b,
                        {
                          component: {
                            ...e.itemComponent,
                            label: ((w = e.itemComponent) == null ? void 0 : w.label) && `${e.itemComponent.label} ${D + 1}`
                          },
                          id: `${t.name}.${D}`,
                          onChangeCallback: n,
                          onChange: g
                        }
                      ) }),
                      V && /* @__PURE__ */ a(
                        et,
                        {
                          icon: U.CROSS,
                          title: "Remove",
                          onClick: () => f(void 0, () => {
                            t.remove(D);
                          }),
                          className: "sds_dynamic-input__option__delete-button"
                        }
                      )
                    ]
                  },
                  D
                );
              }),
              /* @__PURE__ */ a("div", { className: "sds_dynamic-input__add-option-button", children: /* @__PURE__ */ a(
                W,
                {
                  label: e.addItemLabel,
                  onClick: () => f(void 0, () => {
                    (async () => (t.push(void 0), await o.validateField(
                      `${t.name}.${c}`
                    )))();
                  }),
                  leftIcon: U.ADD
                }
              ) })
            ] });
          } })
        }
      ) });
    default:
      return d && B ? /* @__PURE__ */ a(
        lt,
        {
          props: { ...e, ...i },
          type: e.type,
          customComponents: d,
          customComponentsSet: B
        }
      ) : null;
  }
};
b.getYupType = nt;
b.defaultFieldTypes = M;
export {
  b as DynamicInputFormik
};
//# sourceMappingURL=index.js.map
